module.exports = __webpack_public_path__ + "img/rsini_2.9be5477a.jpg";